import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=159ca1c1&scoped=true&"
import script from "./LogoutModal.vue?vue&type=script&lang=ts&"
export * from "./LogoutModal.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=159ca1c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ca1c1",
  null
  
)

export default component.exports